import styled from "styled-components";

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2px;
  text-align: center;
`;

const Year = styled.button<{
  isCurrent: boolean;
  disabled: boolean;
}>`
  padding: 10px 8px;
  border: none;
  border-radius: 4px;
  color: ${({ disabled, isCurrent }) => {
    if (disabled) return "#c0c0c0";
    return isCurrent ? "#ffffff" : "#202227";
  }};
  background-color: ${({ isCurrent }) =>
    isCurrent ? "#337ab7" : "transparent"};
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};

  &:hover {
    ${({ disabled, isCurrent }) => {
      if (!disabled && !isCurrent) return "background:#f0f0f0";
    }};
  }
`;

export type YearViewProps = {
  setCurrentlyShownYear: React.Dispatch<React.SetStateAction<Date>>;
  firstCurrentlyShownYear: Date;
};

export const YearView: React.FC<YearViewProps> = ({
  setCurrentlyShownYear,
  firstCurrentlyShownYear: firstCurrentlyShownYearProp,
}) => {
  const firstCurrentlyShownYear = firstCurrentlyShownYearProp.getFullYear();

  const yearDates: Date[] = [];
  for (let i = firstCurrentlyShownYear; i < firstCurrentlyShownYear + 12; i++) {
    yearDates.push(new Date(i, 0, 1));
  }

  return (
    <Container data-id="year-view-container">
      {yearDates.map((year) => (
        <Year
          type="button"
          isCurrent={new Date().getFullYear() === year.getFullYear()}
          onClick={() => setCurrentlyShownYear(year)}
          disabled={year.getFullYear() < new Date().getFullYear()}
          data-id={`year-${year.getFullYear()}`}
        >
          {year.getFullYear()}
        </Year>
      ))}
    </Container>
  );
};

export default YearView;
